import storeModule from './store-module'
import { defineStore } from 'pinia'

export default defineStore('template-attachments', storeModule.createStoreModule('template-attachments'))
